<template>
  <div class="account-upgrade-page">
    <div class="header">{{ $t("myPlanPage.accountInfo.upgradeTitle") }}</div>
    <div class="main-container">
      <div class="price-container">
        <plan-pricing-package @selected="open"></plan-pricing-package>
      </div>
      <div class="need-more-container">
        <div class="title">Need More?</div>
        <div class="des">
          If Business Plan just doesn’t enough, you may want to try one of our
          custom plans! They work on a tier basis, where each additional account
          costs a little bit less. Contact us for more information about how to
          add more power to your plan.
        </div>
      </div>
      <div style="margin-bottom: 100px">
        <div class="contact-us-btn" @click="contactUsClick">
          {{ $t("common.contactUs") }}
        </div>
      </div>
    </div>
    <subscription
      :planName="selectPlan.planName"
      :billingCycleId="selectPlan.billingCycleId"
      :filter="selectPlan.type"
      v-if="showSubscription"
    ></subscription>
    <paypal-error-confirm
      v-show="showPaypalErrorModal"
      :params="selectPlan"
      @cancel="paypalCancel"
    ></paypal-error-confirm>
  </div>
</template>

<script>
import PlanPricingPackage from "../../components/plan/upgrade/pricing_package/Index.vue";
import subscription from "../../components/plan/upgrade/subscription/Subscription";
import { paypalPay } from "../../service/payment";
import { mapGetters } from "vuex";
import { PAYMENT_INFO } from "../../store/mutation-types";
import paypalErrorConfirm from "../../components/payment/paypal_error_confirm/Index";
import { list as planList } from "../../service/plans";

export default {
  name: "AccountUpgradePage",
  components: { PlanPricingPackage, subscription, paypalErrorConfirm },
  computed: {
    ...mapGetters({
      paymentInfo: PAYMENT_INFO,
    }),
  },
  data() {
    return {
      showPaypalErrorModal: false, // 展示paypal错误提示
      showSubscription: false, // 显示订阅
      from: "", // 前一页
      selectPlan: { planName: "", billingCycleId: "", type: "" }, // 选中项
    };
  },
  methods: {
    /**
     * 打开点击的详情
     */
    open(plan) {
      this.selectPlan.planName = plan.name;
      this.selectPlan.billingCycleId = plan.billingCycles[0].id;
      this.selectPlan.type = plan.type;
      this.$nextTick(() => {
        this.showSubscription = true;
      });
    },
    contactUsClick() {
      window.open(process.env.VUE_APP_CONTACT_US, "_blank");
    },
    /**
     * paypal提示框cancel事件
     */
    paypalCancel() {
      this.showPaypalErrorModal = false;
      this.showSubscription = true;
      // 取消之后清空 PAYMENT_INFO 支付信息
      this.$store.commit(PAYMENT_INFO, null);
    },
    async init() {
      // 如果url中携带了选中项信息，则直接打开选中项
      const { token, paymentId, PayerID } = this.$route.query;
      if (!this.from && this.paymentInfo) {
        const loading = this.$loading();
        try {
          // 默认打开上次选中项
          this.selectPlan.planName = this.paymentInfo.planName;
          this.selectPlan.billingCycleId = this.paymentInfo.billingCycleId;
          this.selectPlan.type = this.paymentInfo.filter;
          this.showSubscription = true;
          if (!token) {
            throw new Error("通过后退回来的");
          }
          // 同时打开上次选中的
          await paypalPay({ token, paymentId, PayerID });
          this.$toast.show({ message: this.$t("common.success") });
          // 成功后关闭订阅
          this.showSubscription = false;
        } catch (e) {
          this.showPaypalErrorModal = true;
          this.showSubscription = false;
        } finally {
          loading.close();
        }
      } else {
        // 说明不是通过paypal跳转回来的
        this.$store.commit(PAYMENT_INFO, null);
      }
    },
  },
  async created() {
    await planList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from.name;
      vm.init();
    });
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.account-upgrade-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .header {
    height: 80px;
    padding: 0 60px;
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 20px;
    border-bottom: 1px solid #eceff1;
  }
  .main-container {
    flex: 1;
    overflow: auto;
    padding: 50px 60px;
    .title {
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 30px;
    }
    .price-container {
      padding-bottom: 30px;
      border-bottom: 1px solid @border-color;
      width: @price-width;
    }
    .need-more-container {
      padding-top: 30px;
      width: @price-width;
      .need-title {
        font-size: 20px;
        font-weight: 600;
      }
      .des {
        font-size: 16px;
        line-height: 23px;
      }
    }
    .contact-us-btn {
      height: 40px;
      border-radius: 2px;
      border: solid 1px @border-color;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
      padding: 0 73px;
      float: left;
      cursor: pointer;
      &:hover,
      &:active {
        opacity: 0.7;
        font-size: 16px;
      }
    }
  }
}
</style>
